import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchSubscription,
  addSubscription,
  updateSubscription,
  deleteSubscription,
  fetchEmployerSubscription,
  fetchCandidateSubscription,
} from "./SubscriptionAPI";

const initialState = {
  data: [],
  loading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  error: null,
};

export const fetchSubscriptionasync = createAsyncThunk(
  "subscription/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchSubscription();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addSubscriptionasync = createAsyncThunk(
  "subscription/add",
  async (newSubscription, { rejectWithValue }) => {
    try {
      const response = await addSubscription(newSubscription);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSubscriptionasync = createAsyncThunk(
  "subscription/update",
  async ({ id, updateSubscriptiondata }, { rejectWithValue }) => {
    try {
      const response = await updateSubscription(id, updateSubscriptiondata);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSubscriptionasync = createAsyncThunk(
  "subscription/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteSubscription(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchEmployerSubscriptionasync = createAsyncThunk(
  "employerSubscription/fetch",
  async (page, { rejectWithValue }) => {
    try {
      return await fetchEmployerSubscription(page);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchCandidateSubscriptionasync = createAsyncThunk(
  "candidateSubscription/fetch",
  async (page, { rejectWithValue }) => {
    try {
      return await fetchCandidateSubscription(page);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch cases
      .addCase(fetchSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //fetchEmployerSubscription
      .addCase(fetchEmployerSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployerSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchEmployerSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //fetchCandidateSubscription
      .addCase(fetchCandidateSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCandidateSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add cases
      .addCase(addSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = [...state.data, action.payload];
        state.error = null;
      })
      .addCase(addSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update cases
      .addCase(updateSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlan = action.payload;
        state.data = state.data.map((plan) =>
          plan.uuid === updatedPlan.uuid ? updatedPlan : plan
        );
        state.error = null;
      })
      .addCase(updateSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete cases
      .addCase(deleteSubscriptionasync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSubscriptionasync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (item) => item.uuid !== action.payload.id
        );
        state.error = null;
      })
      .addCase(deleteSubscriptionasync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectSubscription = (state) => state.subscription.data;
export const selectSubscriptionLoading = (state) => state.subscription.loading;
export const selectSubscriptionError = (state) => state.subscription.error;
export const selectPagination = (state) => state.subscription.pagination;

export default subscriptionSlice.reducer;
